export default "__VITE_ASSET__98132b13__"